var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareSwatch = function SvgSquareSwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "square-swatch_svg__a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#square-swatch_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h4v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M4 0h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 0h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M20 0h4v4h-4zM0 4h4v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M8 4h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 4h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M16 4h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 4h4v4h-4zM0 8h4v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M4 8h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 8h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 8h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M20 8h4v4h-4zM0 12h4v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 12h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M8 12h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M16 12h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 12h4v4h-4zM0 16h4v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M4 16h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 16h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 16h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 16h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M20 16h4v4h-4zM0 20h4v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 20h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M8 20h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 20h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M16 20h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 20h4v4h-4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1,
    d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
  })));
};
export default SvgSquareSwatch;